export type DialogState = 'open' | 'close';
export type DialogCloseCallback = () => void;

export class Dialog {
  state: DialogState = 'open';
  data: any;
  reject!: (data?: any) => unknown;
  resolve!: (data?: any) => unknown;
}
